export default __webpack_public_path__ + "static/media/audioPlay.c05f8904.png";